// extracted by mini-css-extract-plugin
export default {"root":"LoanStatusDialog_root__1kqsL"};